import React from 'react';
import { useFavoriteDashboards as useFavorite } from '@atlassian/jira-favorites-store/src/index.tsx';
import { useRecentDashboards as useRecent } from '@atlassian/jira-recents-store/src/index.tsx';
import { LoadStatus as LoadStatusCommon } from '../../../../common/ui/load-status/main.tsx';
import type { LoadStatusProps } from './types.tsx';

export const LoadStatus = ({ shouldThrowError = false }: LoadStatusProps) => (
	<>
		<LoadStatusCommon shouldThrowError={shouldThrowError} useProvider={useFavorite} />
		<LoadStatusCommon shouldThrowError={shouldThrowError} useProvider={useRecent} />
	</>
);
